import { ReactComponent as FilledAlertInfo } from '../../../../../assets/images/icon-filled-alert-info.svg';

const ClosureDatesNotice = () => {
  return (
    <div className="bg-blue-1 p-6">
      <div className="flex flex-row">
        <div className="mr-4">
          <FilledAlertInfo />
        </div>
        <div className="flex flex-col">
          <div className="font-bold">Cluey closure period</div>
          <div className="mt-3 leading-[24px]">
            Cluey will be closed on 24, 25, 26, & 31 December 2025 and 1 January 2026. Sessions won't be booked on these
            days.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClosureDatesNotice;
